module.exports = __webpack_public_path__ + "img/long-arrow-right-white.d04eb6f2.svg";